import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { usePopoverHandlers, Popover, PopoverType, PopoverPosition, PopoverHeaderAlign, Image, ImageSize, Box, Heading, HeadingType, Text, TextType, Button, IconName, ScrollableList, ScrollableListVariant, CheckboxWithLabel, ButtonVariant, ButtonSize, IconColor, Group, GroupAlign, IconSize, } from '@as/cotopaxi';
import { FUNCTIONAL_KEY } from './CookieMessage';
import CookiePreference from './CookiePreference';
const CookiePreferences = ({ isCookiePreferenceOpen, isCookiePreferencesOpen, checkedPreferences, setIsCookiePreferenceOpen, onCookiePreferenceClose, onCookiePreferencesClose, saveCookiePreferences, changeCookiePreference, showCookiePreference, panel2, logoUrl, preferenceData, }) => {
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({ close: onCookiePreferencesClose });
    const isMobile = useMediaQueryMatchesOnMobile();
    useEffect(() => {
        if (isCookiePreferencesOpen) {
            handlePopoverOpen(null, null, true, true);
        }
    }, [isCookiePreferencesOpen]);
    const closeCookiePreferencesPopup = (group) => {
        handlePopoverClose();
        setIsCookiePreferenceOpen(true);
        showCookiePreference(group);
    };
    const saveCookiePreferencesAndClose = () => __awaiter(void 0, void 0, void 0, function* () {
        yield saveCookiePreferences();
    });
    return (_jsxs(_Fragment, { children: [_jsxs(Popover, { multi: true, disableClickOutside: true, noAnimation: true, anchorEl: anchorEl, type: PopoverType.MODAL, position: PopoverPosition.BOTTOM, onClose: handlePopoverClose, headerAlign: PopoverHeaderAlign.CENTER, title: _jsx(Image, { src: logoUrl, size: ImageSize.COOKIE_BRAND_LOGO }), footerElement: isMobile && (_jsx(Button, { fill: true, text: panel2.btnLabel, onClick: saveCookiePreferencesAndClose, iconRight: {
                        name: IconName.CHEVRON_RIGHT,
                        size: IconSize.MAJOR,
                    } })), children: [_jsxs(Box, { mobile: {
                            spacing: {
                                paddingLeft: 2,
                                paddingRight: 2,
                            },
                        }, tablet: {
                            spacing: {
                                paddingLeft: 4,
                                paddingRight: 4,
                            },
                        }, children: [_jsx(Heading, { type: HeadingType.TITLE, children: panel2.title }), _jsx(Box, { mobile: {
                                    spacing: {
                                        marginTop: 1.5,
                                        marginBottom: 1.5,
                                    },
                                }, children: _jsx(Text, { type: TextType.CONTENT, children: panel2.description }) })] }), _jsx(ScrollableList, { variant: isMobile && ScrollableListVariant.SHADOW, children: _jsx(Box, { mobile: {
                                spacing: {
                                    paddingLeft: 2,
                                    paddingRight: 2,
                                    paddingBottom: 2,
                                },
                            }, tablet: {
                                spacing: {
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                },
                            }, children: panel2.cookieGroups.map((group) => (_jsx(Box, { mobile: {
                                    spacing: {
                                        marginTop: 2,
                                    },
                                }, children: _jsx(CheckboxWithLabel, { id: `cookie-group-${group.key}`, name: "cookie-group", value: group.key, readOnly: group.key === FUNCTIONAL_KEY, defaultChecked: checkedPreferences[group.key], onChange: changeCookiePreference, labelChildren: _jsxs(_Fragment, { children: [_jsx(Text, { emphasized: true, inline: true, children: group.title }), _jsx(Button, { noBubble: true, variant: ButtonVariant.INVERSE_ALT, onClick: () => closeCookiePreferencesPopup(group), size: ButtonSize.SMALL, icon: {
                                                    name: IconName.INFORMATION_OUTLINE,
                                                    color: IconColor.ACTION,
                                                } }), _jsx(Box, { mobile: {
                                                    spacing: {
                                                        marginTop: 0.5,
                                                    },
                                                }, children: _jsx(Text, { children: group.description }) })] }) }) }, group.key))) }) }), !isMobile && (_jsx(Box, { mobile: {
                            spacing: {
                                paddingTop: 3,
                                paddingRight: 4,
                                paddingBottom: 4,
                            },
                        }, children: _jsx(Group, { align: GroupAlign.RIGHT, children: _jsx(Button, { onClick: saveCookiePreferencesAndClose, text: panel2.btnLabel, iconRight: {
                                    name: IconName.CHEVRON_RIGHT,
                                    size: IconSize.MAJOR,
                                } }) }) }))] }), _jsx(CookiePreference, { preferenceData: preferenceData, logoUrl: logoUrl, isCookiePreferenceOpen: isCookiePreferenceOpen, onCookiePreferenceClose: onCookiePreferenceClose })] }));
};
export default CookiePreferences;
